(function () {
  var FREE = 6900;
  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* ---------- 1. Barre livraison offerte (tiroir panier + page panier) ---------- */
  var busy = false;
  function barHTML(total) {
    var left = FREE - total, pct = Math.max(4, Math.min(100, Math.round(total / FREE * 100)));
    var txt = left > 0 ? 'Plus que <b>' + fmt(left) + '</b> pour la livraison offerte' : '✓ <b>Livraison offerte</b> sur ta commande';
    return '<div class="onr-fs-t">' + txt + '</div><div class="onr-fs-w"><div class="onr-fs-b"><span style="width:' + pct + '%"></span></div><span class="onr-fs-i' + (left > 0 ? '' : ' on') + '"><svg viewBox="0 0 24 24"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span></div>';
  }
  function placeBars(total) {
    var spots = [];
    var dr = document.querySelector('cart-drawer .drawer__header');
    if (dr) spots.push(dr);
    var pg = document.querySelector('.cart__items, #main-cart-items');
    if (pg && !document.querySelector('cart-drawer.active')) spots.push(pg);
    spots.forEach(function (s) {
      var b = s.parentNode.querySelector(':scope > .onr-fs');
      if (!b) { b = document.createElement('div'); b.className = 'onr-fs'; s.insertAdjacentElement(s.classList.contains('drawer__header') ? 'afterend' : 'beforebegin', b); }
      b.style.display = total > 0 ? '' : 'none';
      b.innerHTML = barHTML(total);
    });
  }
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { placeBars(c.total_price); })
      .catch(function () {}).finally(function () { busy = false; });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(refresh, 250); }
  function watch() {
    var cd = document.querySelector('cart-drawer');
    if (cd) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { var n = m[i].target; if (!(n.closest && n.closest('.onr-fs'))) { soon(); return; } }
    }).observe(cd, { childList: true, subtree: true });
    var cp = document.querySelector('cart-items');
    if (cp) new MutationObserver(soon).observe(cp, { childList: true, subtree: true });
    refresh();
  }

  /* ---------- 2. Réassurance + 3. bouton collant (fiches produit) ---------- */
  function productPage() {
    var form = document.querySelector('.product__info-container product-form, .product__info-wrapper product-form, main product-form');
    if (!form) return;
    var btn = form.querySelector('button[type=submit][name=add], button[type=submit]');
    if (!btn) return;
    var tpl = document.getElementById('onr-trust-tpl');
    if (tpl && !document.querySelector('.onr-trust')) {
      var box = document.createElement('div'); box.className = 'onr-trust'; box.innerHTML = tpl.innerHTML;
      var pay = document.querySelector('.product__info-container .footer__payment');
      (pay || form).insertAdjacentElement('afterend', box);
    }
    if (window.innerWidth > 749) return;
    var titleEl = document.querySelector('.product__title h1, .product__title, h1');
    var bar = document.createElement('div'); bar.className = 'onr-sticky';
    bar.innerHTML = '<div class="onr-st-i"><span class="onr-st-n"></span><span class="onr-st-p"></span></div><button type="button">Ajouter au panier</button>';
    document.body.appendChild(bar);
    var nameEl = bar.querySelector('.onr-st-n'), priceEl = bar.querySelector('.onr-st-p'), sb = bar.querySelector('button');
    nameEl.textContent = titleEl ? titleEl.textContent.trim().toLowerCase().replace(/^./, function (m) { return m.toUpperCase(); }) : '';
    function sync() {
      var bt = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      var m = bt.match(/·\s*(.+)$/);
      var pr = m ? m[1] : '';
      if (!pr) { var pe = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular'); pr = pe ? pe.textContent.trim() : ''; }
      priceEl.textContent = pr;
      var sold = btn.disabled || /puis/i.test(bt);
      sb.disabled = sold; sb.textContent = sold ? 'Épuisé' : 'Ajouter au panier';
    }
    sync(); new MutationObserver(sync).observe(btn, { childList: true, subtree: true, characterData: true, attributes: true });
    sb.addEventListener('click', function () { btn.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { var below = e.boundingClientRect.top < 0; bar.classList.toggle('on', !e.isIntersecting && below); });
      }).observe(btn);
    }
  }

  function init() { watch(); productPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();